import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Card extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [ 
        {
          title: 'surface',
          isDefault: true,
        },
        'imageBlackout',
        'imageBody',
        'body'
      ],
      modifiers : [],
      states : []
    }

  }
  
  render() {
    const {children, icon, body, surface, imgSrc, imageBlackout, ...rest } = this.props
    const content = <div className="mdn-Card--body-content">
      {children}      
    </div>;
    let type = '';

    if(!imageBlackout && !surface && !body) {
      type = 'surface'
    }
    const props = clearProps(this.props)
    return <div {...props} className={resolveProps(this.props, this.config, 'Card')}>
      {imageBlackout ? <img className="mdn-Card--imageBlackout-image" src={imgSrc}/> : ''}
      {(surface || type === 'surface') ? <span className={'mdn-Card--surface-icon mdn-Icon--md mdn-Icon-'+icon} aria-hidden="true"></span> : ''}
      {body ? content : children}   
  </div>
  }
}

Card.propTypes = {
  icon : PropTypes.string,
  children : PropTypes.node,
  surface : PropTypes.bool,
  body : PropTypes.bool,
  imageBlackout : PropTypes.bool,
  imgSrc : PropTypes.string
}